import { useRuntimeConfig } from "#imports";
import { useUiStore } from "~/stores/useUiStore";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const uiStore = useUiStore();
  const version = config.public.packageVersion;

  uiStore.setPackageVersion(typeof version === "string" ? version : "");
});
